import { selectServerTimezone, selectTimezones } from "store/slices/appSlicer";
import { useAppSelector } from "core/helpers";
import moment from "moment/moment";
import { useLSActions } from "./index";

const useISODate = () => {
  const serverTimezone = useAppSelector(selectServerTimezone);
  const timezoneList = useAppSelector(selectTimezones);
  const { getFromLs } = useLSActions();
  const offsetFromSelector = serverTimezone?.baseOffset.slice(0, -3);

  // Because we do not need "Z" in the end of string
  const getISODate = (time: string[] | Date[]) => {
    return time.map(t => `${moment(t).format("YYYY-MM-DD")}T${moment(t).format("HH:mm:ss")}`);
  };

  const getISODateTimezone = async (
    time: string[] | Date[],
    customOffset?: string | undefined,
  ): Promise<string[]> => {
    const offsetFromLs = await getFromLs("serverTimezone");
    let baseOffset: string | null = null;

    if (typeof offsetFromLs === "string") {
      baseOffset = offsetFromSelector || JSON.parse(offsetFromLs)?.baseOffset.slice(0, -3);
    }

    let offset: string | null = null;

    if (customOffset !== "undefined:undefined" && customOffset) {
      offset = customOffset?.includes("-") ? customOffset : `+${customOffset}`;
    } else {
      offset = baseOffset?.includes("-") ? baseOffset : `+${baseOffset}`;
    }

    return time.map(
      t =>
        `${moment(t)
          .utcOffset(offset as string | number)
          .format("YYYY-MM-DDTHH:mm:ss")}${offset}`,
    );
  };

  return {
    getISODateTimezone,
    serverTimezone,
    getISODate,
    timezoneList,
  };
};

export default useISODate;
